<template>
    <!-- 活动列表页 -->
    <div class="one_Box">
        <div class="title flex">
            <div class="title_t" @click="onPage('index')">
                <img src="../../../assets/image/one/fanhui.png" alt="">
                <span>{{ val }}USD</span>
                <div></div>
            </div>
        </div>

        <div class="goods">
            <div class="goods_box" v-for="el in list" :key="el.id">
                <div class="goods_box_tie">
                    <span>{{ $t('yi18') }}{{ el.phase_sn }}{{ $t('yi19') }}</span>
                    <!-- <span class="countdown">{{ formatCountdown(el.remainingTime) }}</span> -->
                </div>
                <div class="goods_box_le">
                    <img :src="el.goods_image" alt="">
                    <div class="goods_box_le_text">
                        <div style="flex: 1;"> {{ el.goods_name }}</div>
                        <div style="margin-top: 10px;">{{ $t('yi20') }}<span>{{ el.usd }}usd</span></div>
                    </div>
                </div>
                <div class="goods_box_ri">
                    <p class="progress">
                        <span :style="'width: ' + ((el.slots_sold / el.max_slots) * 100).toFixed(2) + '%'"></span>
                    </p>

                    <div class="goods_box_ri_box">
                        <div>
                            <span>{{ el.slots_sold || 0 }}</span>
                            <p>{{ $t('yi9') }}</p>
                        </div>
                        <div>
                            <span>{{ el.max_slots || 0 }}</span>
                            <p>{{ $t('yi10') }}</p>
                        </div>
                        <div>
                            <span>{{ (Number(el.max_slots) - Number(el.slots_sold)) || 0 }}</span>
                            <p>{{ $t('yi11') }}</p>
                        </div>
                    </div>

                    <div class="goods_box_ri_btn">
                        <div @click="onPage('gdsDes', el)"> {{ el.is_buy == 0 ? $t('yi12') : $t('yi13') }}</div>
                        <!-- <div @click="onPage('index')">{{ $t('yi14') }}</div> -->
                    </div>
                </div>
            </div>

            <div class="more" v-if="(page * limit) < goods.total" @click="more">{{ $t('yi15') }}</div>
            <div v-if="list.length <= 0">{{ $t('yi16') }}</div>
        </div>
    </div>
</template>

<script>
import { UsdActivityList } from '../../../api/memberOne';

export default {
    props: {
        val: {
            default: '',
            type: String / Object
        },
    },
    data() {
        return {
            page: 1,
            limit: 10,
            goods: [],
            list: [],
            intervalId: null, // 用于存储定时器的 ID
        }
    },
    created() {
        this.getUsdActivityList();
        // this.startCountdown();
    },
    beforeDestroy() {
        // 清除定时器
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    methods: {
        onPage(v, val) {
            this.$emit('onPage', v, val);
        },
        more() {
            this.page++;
            this.getUsdActivityList();
        },
        getUsdActivityList(v = 0) {
            const { val, page, limit } = this;
            UsdActivityList({
                usd: val, page, limit
            }, 'one').then(res => {
                if (res && res.result) {
                    if (v == 1) {
                        setTimeout(() => {
                            this.goods = res.result;
                            this.list = res.result.data.map(item => ({
                                ...item,
                                remainingTime: item.deadline_time // 初始化剩余时间
                            }));
                        }, 10);
                        return;
                    }
                    this.goods = res.result;
                    this.list = res.result.data.map(item => ({
                        ...item,
                        remainingTime: item.deadline_time // 初始化剩余时间
                    }));
                }
            });
        },
        startCountdown() {
            this.intervalId = setInterval(() => {
                this.list = this.list.map(item => {
                    return {
                        ...item,
                        remainingTime: Math.max(0, item.remainingTime - 1) // 每秒减少 1
                    };
                });
            }, 1000);
        },
        formatCountdown(timeLeftInSeconds) {
            let timeLeft = timeLeftInSeconds * 1000;

            timeLeft = Math.max(0, timeLeft);

            const hours = String(Math.floor(timeLeft / (1000 * 60 * 60))).padStart(2, '0');
            const minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
            const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0');

            return `${hours}:${minutes}:${seconds}`;
        },
        onUpdateSlotsSold(data) {
            const itemIndex = this.list.findIndex(item => item.id === data.activity_id);
            if (itemIndex !== -1) {
                const updatedItem = {
                    ...this.list[itemIndex],
                    slots_sold: this.list[itemIndex].slots_sold + data.buy_nums
                };
                this.$set(this.list, itemIndex, updatedItem);
            }
        },
    }
}
</script>

<style scoped lang="scss">
.flex {
    display: flex;
}

.one_Box {
    overflow-y: auto;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title {
        align-items: center;
        justify-content: space-between;

        .title_t {
            font-size: 14px;
            color: #000;
            font-weight: bold;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;

            img {
                margin-right: 5px;
                width: 8px;
                height: 14px;
            }

            div {
                position: absolute;
                left: 0;
                bottom: -5px;
                width: 100%;
                height: 5px;
                background: linear-gradient(90deg, #F21D19 0%, #FFF5F4 100%);
                border-radius: 8px;
            }
        }

        .title_x {
            cursor: pointer;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }

    .goods::-webkit-scrollbar {
        display: none;
    }
    .goods {
        flex: 1;
        overflow-y: auto;
        margin: 20px 0 0;
        scrollbar-width: none;
        -ms-overflow-style: none;

        .goods_box {
            display: flex;
            padding: 10px;
            box-sizing: border-box;
            margin-bottom: 10px;
            border-radius: 8px;
            border: 1px solid #F45C1D;
            background: linear-gradient(-32deg, #FFE8E0 0%, #FFFAF9 100%);
            display: flex;
            flex-direction: column;

            .goods_box_tie {
                color: #666666;
                font-size: 12px;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                .countdown{color:#E8090C;}
            }

            .goods_box_le {
                img {
                    width: 100px;
                    height: 58px;
                    margin-bottom: 5px;
                    margin-right: 15px;
                    object-fit: contain;
                    border: 1px solid #ccc;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 5px;
                    background: #fff;
                }

                display: flex;

                .goods_box_le_text {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;

                    div:nth-child(1) {
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-line-clamp: 3;
                        line-height: 12px;
                    }

                    div:nth-child(2) {
                        padding-bottom: 10px;
                        box-sizing: border-box;
                    }

                    span {
                        color: #EA190F;
                        font-size: 12px;
                    }
                }

                font-size: 12px;
            }

            .goods_box_ri {
                margin-top: 5px;
                flex: 1;
                display: flex;
                flex-direction: column;

                .progress {
                    height: 8px;
                    background: #c10714;
                    border: 1px solid #DBDBDB;
                    position: relative;
                    border-radius: 8px;

                    span {
                        height: 10px;
                        background: url('../../../assets/image/one/Announced_4A.gif') center center repeat-x;
                        position: absolute;
                        top: -1px;
                        left: -1px;
                        font-size: 0;
                        border-radius: 8px;
                    }
                }

                .goods_box_ri_box {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    font-size: 12px;
                    flex: 1;
                    margin-top: 10px;
                    text-align: center;
                }

                .goods_box_ri_btn {
                    padding: 20px 20px 10px;
                    box-sizing: border-box;

                    div {
                        cursor: pointer;
                        width: 100%;
                        margin: 10px auto 0;
                        background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
                        border-radius: 22px;
                        color: #fff;
                        font-size: 12px;
                        padding: 10px 0px;
                        text-align: center;
                    }
                }
            }
        }

        .more {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            text-align: center;
            height: 30px;
            border-radius: 20px;
            border: 1px solid #FE3421;
            font-size: 16px;
            color: #FE3421;
        }
    }

    .more {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 99%;
        text-align: center;
        height: 30px;
        border-radius: 20px;
        border: 1px solid #FE3421;
        font-size: 16px;
        color: #FE3421;
    }
}
</style>